import './assets/ResultsTable.css';const _ = {
  "results-table": "_results-table_azyuq_1",
  "results-table__row": "_results-table__row_azyuq_4",
  "results-table__item": "_results-table__item_azyuq_9",
  "results-table__header": "_results-table__header_azyuq_9",
  "results-table__title-row": "_results-table__title-row_azyuq_16",
  "results-table__title": "_results-table__title_azyuq_16",
  "results-table__mobile-label": "_results-table__mobile-label_azyuq_24",
  "results-table__no-results": "_results-table__no-results_azyuq_34",
  "results-table--compact": "_results-table--compact_azyuq_40",
  "results-table__header-row": "_results-table__header-row_azyuq_50",
  "results-table__hide-on-mobile": "_results-table__hide-on-mobile_azyuq_70",
  "fade-in__wrapper": "_fade-in__wrapper_azyuq_113",
  "page-fade-in": "_page-fade-in_azyuq_1"
};
export {
  _ as s
};
